<template>
  <!--    :close-on-press-escape="closeOnPressEscape"-->
  <div class="dialog-header">
    <slot name="title">
      <span class="el-dialog__title">{{ title }}</span>
    </slot>
    <div>
      <button
        type="button"
        class="el-dialog__headerfullbtn"
        aria-label="Fullscreen"
        @click="
          () => {
            mFullscreen = !mFullscreen;
          }
        "
      >
        <el-tooltip
          :enterable="false"
          effect="dark"
          :content="mFullscreen ? '还原' : '最大化'"
          placement="bottom"
        >
          <i class="el-icon-full-screen"></i>
        </el-tooltip>
      </button>
      <button
        type="button"
        class="el-dialog__headerfullbtn"
        aria-label="Close"
        @click="handleClose"
      >
        <el-tooltip effect="dark" content="关闭" placement="bottom">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </el-tooltip>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "MDialog",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // mVisible: this.visible,
      mFullscreen: false,
    };
  },
  watch: {
    mFullscreen(n) {
      this.$emit('update:mFullscreen', n)
    }
  },
  methods: {
    handleClose() {
      this.$emit("cancel");
    },
  },
};
</script>
<style lang="less" scoped>
  @import '~@/assets/style/innerDialog.less';
</style>